//sudo rm -rf /var/www/html/static
//sudo mv /home/jordan/good-call/build/* /var/www/html/
// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './App.css';
import CocktailDetailPage from './CocktailDetailPage';
import CocktailsListPage from './CocktailsListPage';
import LoginPage from './LoginPage';
import HomePage from './HomePage';
import ListsPage from './ListsPage';
import SpiritPage from './SpiritPage';
import MyBarPage from './MyBarPage';
import apiClient from './apiClient'; // Import the API client


function ProtectedRoute({ userData, children, onTokenRefreshFailed }) {
  const isAuthenticated = userData && userData.userid && userData.access_token;
  if (!isAuthenticated) {
    onTokenRefreshFailed(); // Call logout if userData is invalid
    return <Navigate to="/" />;
  }
  return children;
}

function YourBarPage() {
  return <div className="page-content"><h2>Your Bar</h2><p>Manage your ingredients.</p></div>;
}

function ProfilePage() {
  return <div className="page-content"><h2>Profile</h2><p>Account settings and log.</p></div>;
}

function App() {
  const [userData, setUserData] = useState(null);
  const [lists, setLists] = useState([]);
  const [isLoadingUserData, setIsLoadingUserData] = useState(true);

  useEffect(() => {
    const fetchLists = async () => {
      try {
        const data = await apiClient.request(`/api/lists?userid=${userData.userid}`, {
          method: 'GET',
        });
        setLists(data || []);
      } catch (err) {
        console.error('Failed to fetch lists:', err);
      }
    };

    if (userData && userData.userid && userData.access_token) {
      fetchLists();
    }
  }, [userData, apiClient]);

  const handleUpdateLists = (updatedLists) => {
    setLists(updatedLists);
  };

  useEffect(() => {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      setUserData(parsedData);
      apiClient.setTokens(parsedData.access_token, parsedData.refresh_token);
    }
    setIsLoadingUserData(false);
  }, []);

  useEffect(() => {
    if (userData && userData.userid && userData.access_token) {
      apiClient.setTokens(userData.access_token, userData.refresh_token);
      localStorage.setItem('userData', JSON.stringify(userData));
    }
  }, [userData]);

  useEffect(() => {
    const fetchLists = async () => {
      try {
        const data = await apiClient.request(`/api/lists?userid=${userData.userid}`, {
          method: 'GET',
        });
        setLists(data || []);
      } catch (err) {
        console.error('Error fetching lists:', err);
        if (err.message === 'Failed to refresh token') {
          handleTokenRefreshFailed();
        }
      }
    };
    if (userData && userData.userid && userData.access_token) {
      fetchLists();
    }
  }, [userData]);

  const handleLogout = () => {
    setUserData(null);
    apiClient.clearTokens();
  };

  const handleTokenRefreshFailed = () => {
    handleLogout();
    // Navigate to login page (handled by ProtectedRoute)
  };

  if (isLoadingUserData) {
    return <div>Loading...</div>;
  }

  return (
    <GoogleOAuthProvider
      clientId="558734281451-s05l2ovofetb3ehtvlupo0q340mmcj7p.apps.googleusercontent.com"
      use_fedcm_for_prompt={true}
    >
      <Router>
        <div className="app">
          <Routes>
            <Route path="/" element={<LoginPage setUserData={setUserData} />} />
            <Route
              path="/home"
              element={
                <ProtectedRoute userData={userData} onTokenRefreshFailed={handleTokenRefreshFailed}>
                  <HomePage userData={userData} onLogout={handleLogout} apiClient={apiClient} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-bar"
              element={
                <ProtectedRoute userData={userData} onTokenRefreshFailed={handleTokenRefreshFailed}>
                  <MyBarPage 
                    userData={userData} 
                    apiClient={apiClient} 
                    lists={lists}
                    onUpdateLists={handleUpdateLists}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lists"
              element={
                <ProtectedRoute userData={userData} onTokenRefreshFailed={handleTokenRefreshFailed}>
                  <ListsPage 
                    userData={userData} 
                    apiClient={apiClient} 
                    lists={lists}
                    onUpdateLists={handleUpdateLists}
                  />
                </ProtectedRoute>
              }
            />
            {/* Cocktails listed by listid */}
            <Route
              path="/cocktails/:listid"
              element={
                <ProtectedRoute userData={userData} onTokenRefreshFailed={handleTokenRefreshFailed}>
                  <CocktailsListPage 
                    userData={userData} 
                    lists={lists} 
                    apiClient={apiClient} 
                    onLogout={handleLogout}
                    onUpdateLists={handleUpdateLists}
                  />
                </ProtectedRoute>
              }
            />
            {/* Cocktails listed by typeid - i.e. Bourbon = 34 */}
            <Route
                path="/cocktails/type/:typeid"
                element={
                <ProtectedRoute userData={userData} onTokenRefreshFailed={handleTokenRefreshFailed}>
                    <CocktailsListPage 
                      userData={userData} 
                      lists={lists} 
                      apiClient={apiClient} 
                      onLogout={handleLogout}
                      onUpdateLists={handleUpdateLists}
                    />
                </ProtectedRoute>
                }
            />
            <Route
              path="/cocktail/:drinkid"
              element={
                <ProtectedRoute userData={userData} onTokenRefreshFailed={handleTokenRefreshFailed}>
                  <CocktailDetailPage userData={userData} apiClient={apiClient} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/spirit"
              element={
                <ProtectedRoute userData={userData} onTokenRefreshFailed={handleTokenRefreshFailed}>
                  <SpiritPage userData={userData} apiClient={apiClient} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute userData={userData} onTokenRefreshFailed={handleTokenRefreshFailed}>
                  <ProfilePage onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
